import { Component, Input } from "@angular/core";
import { DashboardBlockLayoutComponent } from "../dashboard-block-layout/dashboard-block-layout.component";

@Component({
  selector: "app-dashboard-counter",
  templateUrl: "./dashboard-counter.component.html",
  styleUrl: "./dashboard-counter.component.scss",
  imports: [DashboardBlockLayoutComponent],
})
export class DashboardCounterComponent {
  @Input()
  label: string;

  @Input()
  labelIcon: string;

  @Input()
  icon: string;

  @Input()
  amount: number;
}
